"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UIConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = tape_sanitizer_1.Ai2CsvTransformationSchema.omit({
    srcDataTape: true,
}).extend({
    operation: zod_1.z.literal('ai2Csv'),
    srcArtifactSlug: zod_1.z.string(),
});
exports.UIConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
});
exports.nodeType = 'operation_ai2Csv';
//# sourceMappingURL=types.js.map